import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { formatAmount, formatQuantity } from './utils/crmNumberFormat'

Vue.prototype.$fmtAmount = formatAmount
Vue.prototype.$fmtQty = formatQuantity

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/zh-CN'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/portal-date-picker.css'
import './styles/mobile-adapt.css'
import './styles/sticky-table-header.css'
import PortalDatePicker from './components/PortalDatePicker.vue'
import StickyTableHeader from './utils/stickyTableHeader'

Vue.use(ElementUI, { locale })
Vue.component('PortalDatePicker', PortalDatePicker)
Vue.directive('sticky-table-header', StickyTableHeader)

Vue.config.productionTip = false

const BUILD_ID = process.env.VUE_APP_BUILD_ID || ''
const BUILD_STORAGE_KEY = 'portal_fe_build_id'
const BUILD_RELOAD_KEY = 'portal_fe_build_reloading'

function syncFrontendBuild() {
  if (!BUILD_ID || process.env.NODE_ENV !== 'production') return

  const stored = localStorage.getItem(BUILD_STORAGE_KEY)
  if (stored === BUILD_ID) {
    sessionStorage.removeItem(BUILD_RELOAD_KEY)
    return
  }

  // 已用新版本触发过一次刷新，写入版本号，避免循环刷新
  if (sessionStorage.getItem(BUILD_RELOAD_KEY) === BUILD_ID) {
    localStorage.setItem(BUILD_STORAGE_KEY, BUILD_ID)
    sessionStorage.removeItem(BUILD_RELOAD_KEY)
    return
  }

  sessionStorage.setItem(BUILD_RELOAD_KEY, BUILD_ID)
  window.location.reload()
}

syncFrontendBuild()

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
